import { ReactComponent as BananaSplit } from "./banana-split.svg";
import { ReactComponent as Beef } from "./beef.svg";
import { ReactComponent as Beer } from "./beer.svg";
import { ReactComponent as Block } from "./block.svg";
import { ReactComponent as Bread } from "./bread.svg";
import { ReactComponent as Candy } from "./candy.svg";
import { ReactComponent as Champagne } from "./champagne.svg";
import { ReactComponent as Children } from "./children.svg";
import { ReactComponent as Cigarette } from "./cigarette.svg";
import { ReactComponent as Coffee } from "./coffee.svg";
import { ReactComponent as Cookie } from "./cookie.svg";
import { ReactComponent as Croissant } from "./croissant.svg";
import { ReactComponent as Cup } from "./cup.svg";
import { ReactComponent as Delivery } from "./delivery.svg";
import { ReactComponent as Dessert } from "./dessert.svg";
import { ReactComponent as FishSalad } from "./fish-salad.svg";
import { ReactComponent as FoodAndWine } from "./food-and-wine.svg";
import { ReactComponent as FrenchFries } from "./french-fries.svg";
import { ReactComponent as Grape } from "./grape.svg";
import { ReactComponent as Ham } from "./ham.svg";
import { ReactComponent as Hamburguer } from "./hamburguer.svg";
import { ReactComponent as IceCream } from "./ice-cream.svg";
import { ReactComponent as IcePop } from "./ice-pop.svg";
import { ReactComponent as Kebab } from "./kebab.svg";
import { ReactComponent as Ketchup } from "./ketchup.svg";
import { ReactComponent as Meal } from "./meal.svg";
import { ReactComponent as More } from "./more.svg";
import { ReactComponent as Noodles } from "./noodles.svg";
import { ReactComponent as PizzaSlice } from "./pizza-slice.svg";
import { ReactComponent as Sausage } from "./sausage.svg";
import { ReactComponent as SeaFood } from "./sea-food.svg";
import { ReactComponent as Shrimp } from "./shrimp.svg";
import { ReactComponent as Soda } from "./soda.svg";
import { ReactComponent as Sushi } from "./sushi.svg";
import { ReactComponent as Taco } from "./taco.svg";
import { ReactComponent as Vegan } from "./vegan.svg";
import { ReactComponent as Water } from "./water.svg";
import { ReactComponent as Featured } from "./featured.svg";
import { ReactComponent as Weight } from "./weight.svg";

const categoryIconsMap: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  "banana-split": BananaSplit,
  featured: Featured,
  beef: Beef,
  beer: Beer,
  block: Block,
  bread: Bread,
  candy: Candy,
  champagne: Champagne,
  children: Children,
  cigarette: Cigarette,
  coffee: Coffee,
  cookie: Cookie,
  croissant: Croissant,
  cup: Cup,
  delivery: Delivery,
  dessert: Dessert,
  "fish-salad": FishSalad,
  "food-and-wine": FoodAndWine,
  "french-fries": FrenchFries,
  grape: Grape,
  ham: Ham,
  hamburguer: Hamburguer,
  "ice-cream": IceCream,
  "ice-pop": IcePop,
  kebab: Kebab,
  ketchup: Ketchup,
  meal: Meal,
  more: More,
  noodles: Noodles,
  "pizza-slice": PizzaSlice,
  sausage: Sausage,
  "sea-food": SeaFood,
  shrimp: Shrimp,
  soda: Soda,
  sushi: Sushi,
  taco: Taco,
  vegan: Vegan,
  water: Water,
  weight: Weight,
};

export default categoryIconsMap;